import {Load} from './Appointment';

export function show(date, time) {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_FORM',
            payload: {
                date: date,
                time: time
            }
        });
    }
}

export function hide() {
    return (dispatch) => {
        dispatch({
            type: 'HIDE_FORM',
            payload: {}
        });
    }
}

export function hideSuccessPopup() {
    return (dispatch) => {
        dispatch({
            type: 'APPOINTMENT_CLOSE',
            payload: {}
        });
    }
}

export function hideErrorPopup() {
    return (dispatch) => {
        dispatch({
            type: 'APPOINTMENT_CLOSE',
            payload: {}
        });
    }
}

export function handle(data) {
    $('.form-error').html('');
    data.map((item) => {
        $('#' + item.attribute + '-error').html(item.value[0]);
    })
}

export function handleCreate(data) {
    return (dispatch) => {
        if(data.status !== 'success') {
            return;
        }
        dispatch({
            type: 'APPOINTMENT_OK',
            payload: {
                ticketCount: data.ticketNum,
                ruDay: data.ruDay,
                date: data.date,
                time: data.time,
                showModal: false
            }
        });
    }
}

export function Validate() {
    $.ajax({
        url: '/api/appointment-validate',
        data: $('#appointment-form').serialize(),
        method: 'POST',
        success: function (data) {
            handle(data);
        }
    });
}

export function Send(e, gender, cabinetId, serviceId = 0, offset = 0, context=false) {
    return (dispatch) => {
        e.preventDefault();
        let genderNumber = 1
        if(gender === "male"){
            genderNumber = 0
        }
        const formGender = `&AppointmentForm%5Bgender%5D=${genderNumber}`
        const formCabinetId = `&AppointmentForm%5Bcabinet_service_id%5D=${cabinetId}`
        const formState = $('#appointment-form').serialize()
        const formStateWithGender = formState + formGender + formCabinetId
        $.ajax({
            url: '/api/appointment-validate',
            data: formStateWithGender,
            method: 'POST',
            success: function (data) {
                handle(data);
                if (data.length === 0) {
                    context ? context.setState({disabled: true}) : null;
                    $.ajax({
                        url: '/api/appointment-create',
                        data: formStateWithGender,
                        method: 'POST',
                        success: function (data) {
                            if(data.status === 'success'){
                                dispatch({
                                    type: 'APPOINTMENT_OK',
                                    payload: {
                                        ticketCount: data.ticketNum,
                                        ruDay: data.ruDay,
                                        date: data.date,
                                        time: data.time,
                                        showModal: false
                                    }
                                });
                            } else {
                                dispatch({
                                    type: 'APPOINTMENT_FAIL',
                                    payload: {
                                        hasError: true,
                                        showModal: false,
                                        msg: data.msg
                                    }
                                });
                            }
                            context ? context.setState({disabled: false}) : null;
                            dispatch(Load(offset, serviceId, gender));
                        }
                    });
                }
            }
        });
    }
}




// WEBPACK FOOTER //
// frontend/src/actions/FormHandler.js